import React from 'react';
import DashboardPage from './DashboardPage';
import NewDashboardPage from './NewDashboardPage';
import { useAmplitudeExperiment } from '../../utils/ampli';
import config from 'config';
import { selectUser } from '../../reducers/user.selectors';
import { useSelector } from 'react-redux';
import { useNewDesign } from '../../state/DesignPreferenceContextProvider';
import { useNewNavigation } from '../../utils/useNewNavigation';
import useRouter from '../../utils/useRouter';

const DashboardPageContainer: React.FC = () => {
  const user = useSelector(selectUser);
  const { variant, isReady } = useAmplitudeExperiment(user, config.amplitudeExperiments.showNewDashboard);
  const { prefersNewDesign } = useNewDesign();
  const showNewNavigation = useNewNavigation();
  const { match: { location: { query } } } = useRouter();

  const hasQueryOverride = query['isNewDashboardPage'] === 'true';

  if ((isReady && variant === 'on' && prefersNewDesign  && showNewNavigation) || hasQueryOverride) {
    return <NewDashboardPage />;
  } else {
    return <DashboardPage />;
  }
};

export default DashboardPageContainer;

